/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './LocationsOccupiedComponent.module.scss';
import metadata from './LocationsOccupiedComponent.metadata.json5';

function LocationsOccupiedComponent(props) {

    const {
        data: LocOccVM,
        updateWizardData,
        submissionVM,
        LocOccPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const addLocOcc = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            LocOccVM.value = LocOccVM.value || []

            const { _xCenter, _dtoName } = LocOccVM;

            const LocOccObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            LocOccObjVM.value.isValidationReq = true

            LocOccVM.pushElement(
                LocOccObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, LocOccVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            LocOccVM.value.splice(index, 1);
            _.set(submissionVM.value, LocOccPath, LocOccVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, LocOccPath, LocOccVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'name01') {
                const value = item.name01 ? item.name01 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.name01 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'desOfOpe') {
                const value = item.desOfOpe ? item.desOfOpe : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desOfOpe = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`LocOccTable`]: {
            data: LocOccVM.value,
        }

    }), [LocOccVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addLocOcc,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            LocOccVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [LocOccVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={LocOccVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

LocationsOccupiedComponent.propTypes = wizardProps;
export default withRouter(LocationsOccupiedComponent);
